import React from 'react'
import { ButtonClean } from '../../../../components'

import { AnalyticsContext, AnalyticsFilterType } from '../../AnalyticsContext'
import {
  ModalFilterEntitiesControlContext,
  ModalFilterEntitiesEnum
} from '../../../../components/common/entityFiltersModals'

type ButtonToggleFilterModalProps = {
  Icon: React.FC
  title: string
  filterId: keyof AnalyticsFilterType
  modalId: ModalFilterEntitiesEnum
}

export const ButtonToggleFilterModal: React.FC<ButtonToggleFilterModalProps> =
  ({ Icon, title, filterId, modalId }) => {
    const { filter } = React.useContext(AnalyticsContext)
    const { showModal } = React.useContext(ModalFilterEntitiesControlContext)

    return (
      <ButtonClean
        className="DropdownLink"
        onClick={() => showModal(modalId)}
        disabled={!!filter[filterId]}
        justifyContent="start"
      >
        <Icon />
        {title}
      </ButtonClean>
    )
  }
